import { GBP } from '@dinero.js/currencies';
import { dinero, Dinero as OGDinero, toDecimal } from 'dinero.js';
import { z } from 'zod';

const parseLocalisedCurrency = (text: string | number, locale: string) => {
  if (typeof text === 'number') {
    return text;
  }

  const thousandSeparator = Intl.NumberFormat(locale)
    .format(11111)
    .replace(/\p{Number}/gu, '');
  const decimalSeparator = Intl.NumberFormat(locale)
    .format(1.1)
    .replace(/\p{Number}/gu, '');

  const float = parseFloat(
    text.replace(new RegExp('\\' + thousandSeparator, 'g'), '').replace(new RegExp('\\' + decimalSeparator), '.')
  );
  const decimal = float.toFixed(2);
  const smaller = parseFloat(decimal) * 100;
  const integer = parseInt(smaller.toFixed(0));
  return integer;
};

export const Currency = z.custom<number | string>().transform((value, ctx) => {
  const number = parseLocalisedCurrency(value, 'en-GB');
  if (isNaN(number)) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Not a valid currency'
    });
    return z.NEVER;
  }

  return number;
});

export const Dinero = z.custom<string | OGDinero<number>>().transform((value, ctx) => {
  const parsedValue = typeof value === 'string' ? value : toDecimal(value);
  const amount = parseLocalisedCurrency(parsedValue, 'en-GB');
  try {
    return dinero({ amount, currency: GBP });
  } catch (e) {
    ctx.addIssue({
      code: z.ZodIssueCode.custom,
      message: 'Not valid currency'
    });

    return z.NEVER;
  }
});
